export class ListenerRegistry<T extends (...args: any[]) => void> {
  private listeners: Record<string, T> = {};

  add(key: string, listener: T): void {
    this.listeners[key] = listener;
  }

  remove(key: string): void {
    delete this.listeners[key];
  }

  notify(...args: Parameters<T>): void {
    for (const listener of Object.values(this.listeners)) {
      listener(...args);
    }
  }
}
